import HardRebootsModal from './hard-reboots-modal.connect'

export default HardRebootsModal
